import React from 'react'

const SortTriangle = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 14L12 17L9 14L15 14Z"
        fill="#8183A2"
        stroke="#8183A2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 10L12 7L9 10L15 10Z"
        fill="#8183A2"
        stroke="#8183A2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

  )
}

export default SortTriangle